import { render, staticRenderFns } from "./public-conversation-comment-request.vue?vue&type=template&id=a14d8228&scoped=true&"
import script from "./public-conversation-comment-request.vue?vue&type=script&lang=js&"
export * from "./public-conversation-comment-request.vue?vue&type=script&lang=js&"
import style0 from "./public-conversation-comment-request.vue?vue&type=style&index=0&id=a14d8228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14d8228",
  null
  
)

export default component.exports